/**
 * 用户个人中心相关操作
 */

import Utils from './utils/utils'
import Global from './global'

import '../css/ucenter.css'

const tpl = $('#tpl_now').text();

$(function () {
    let $mineSetting = $('.container#mine-setting');

    Global.getUserInfo({isUpdate: true}, (res) => {
        $('.header_user .top-nav #user-menu .item:nth-child(1) a').text(res.nickname);
        if ('mine_setting_basic' === tpl) {
            // 昵称
            $mineSetting.find('#section-mine-setting #name .field .nickname').text(res.nickname);
            $mineSetting.find('#section-mine-setting #name input[name=nickname]').val(res.nickname);

            // 简介
            $mineSetting.find('#section-mine-setting #comment input[name=comment]').val(res.comment);

            // 性别
            if (res.sex_type == 1) {
                let item = $mineSetting.find('#section-mine-setting #sex .radio-group .radio-item')[0];
                $(item).addClass('active').children('input[type=radio]').attr('checked', true);
            } else if (res.sex_type == 2) {
                let item = $mineSetting.find('#section-mine-setting #sex .radio-group .radio-item')[1];
                $(item).addClass('active').children('input[type=radio]').attr('checked', true);
            }

            let open_platform_cnt = 0;
            res.unions.forEach((union) => {
                if ([1,2,3].indexOf(Number(union.utype)) > -1 && union.status == 1) {
                    open_platform_cnt++;
                }
            });

            // 手机号、邮箱与第三方账号绑定
            res.unions.forEach((union) => {
                let unick = union.unick;

                if (union.utype == 4) { // phone
                    let $phone = $mineSetting.find('#section-mine-setting #phone');
                    let phoneNumber = unick.substr(0,3) + '*****' + unick.substr(-3,3);
                    $phone.find('.field').html(`<p>${phoneNumber}</p><a href='/mine/setting_phone?op=change'>更换</a>`)

                } else if (union.utype == 5) {  // email
                    let $email = $mineSetting.find('#section-mine-setting #email');
                    let email = unick;
                    $email.find('.field').html(`<p>${email}</p><a href='/mine/setting_email?op=change'>更换</a>`);

                } else if (union.utype == 1) {  // qq
                    if (union.status == 1) {
                        let $qq = $mineSetting.find('#section-mine-setting #third-plt .third-plt-list #qq');
                        $qq.attr('bind', '1');
                        if (open_platform_cnt <= 1) {
                            $qq.children('a').attr('target', '_self').find('span').remove();
                        } else {
                            $qq.find('a span').addClass('active').text('取消绑定');
                        }
                    }

                } else if (union.utype == 2) {  // wechat
                    if (union.status == 1) {
                        let $wechat = $mineSetting.find('#section-mine-setting #third-plt .third-plt-list #wechat');
                        $wechat.attr('bind', '1');
                        if (open_platform_cnt <= 1) {
                            $wechat.children('a').attr('target', '_self').find('span').remove();
                        } else {
                            $wechat.find('a span').addClass('active').text('取消绑定');
                        }
                    }

                } else if (union.utype == 3) {  // weibo
                    if (union.status == 1) {
                        let $weibo = $mineSetting.find('#section-mine-setting #third-plt .third-plt-list #weibo');
                        $weibo.attr('bind', '1');
                        if (open_platform_cnt <= 1) {
                            $weibo.children('a').attr('target', '_self').find('span').remove();
                        } else {
                            $weibo.find('a span').addClass('active').text('取消绑定');
                        }
                    }
                }
            });

            $mineSetting.find('#third-plt .third-plt-list .third-plt-item').each(function (item) {
                // 没有绑定
                if (! $(this).attr('bind')) {
                    generateSocialMediaBindUrl($(this).find('a'));
                }
            });

            // 绑定结果处理
            if (Utils.UrlParams()._bindType) {
                let bindTypeName = 'QQ';
                if (Utils.UrlParams()._bindType == 2) {
                    bindTypeName = '微信';
                }
                if (Utils.UrlParams()._bindType == 3) {
                    bindTypeName = '新浪微博';
                }

                let bindStatus = Utils.UrlParams()._bindStatus;
                if (bindStatus) {
                    // 绑定失败
                    if (bindStatus != 1) {
                        $('.popup-modal.modal-bind').show();
                        $('.popup-modal.modal-bind .content p:nth-child(2) span').text(bindTypeName);
                        setTimeout(function () {
                            location.href = '/mine/setting';
                        }, 2000);
                    } else {
                        $('.popup-modal.modal-bind-success').show();
                        setTimeout(function () {
                            location.href = '/mine/setting';
                        }, 2000);
                    }
                }
            }
        }

        if ('mine_setting_phone' === tpl) {
            let phone1 = '';
            res.unions.map(union => {
                if (union.utype == 4) {
                    phone1 = union.unick
                }
            });

            if (phone1) {
                if (Utils.UrlParams().op === 'change') {
                    let phone2 = phone1.substr(0,3) + '*****' + phone1.substr(-3,3);
                    $('.section-wrapper .form-section.change #input-validate-email[data-step=\'1\']').find('.input-item#phone .origin-phone').text('原绑定手机：' + phone2)
                    $('.section-wrapper .form-section.change #input-validate-email[data-step=\'1\']').find('.input-item#phone input#phone').val(phone1)
                } else {
                    window.location.href = '/mine/setting_phone?op=change'
                }
            } else {
                if (Utils.UrlParams().op === 'change') {
                    window.location.href = '/mine/setting_phone'
                }
            }
        }

        // 用户更换邮箱
        if ('mine_setting_email' === tpl) {
            let email = '';
            res.unions.map(union => {
                if (union.utype == 5) {
                    email = union.unick
                }
            });

            if (email) {
                if (Utils.UrlParams().op === 'change') {
                    let $org = $('.section-wrapper .form-section #input-validate-email .input-item.origin-email');
                    $org.children('.origin-email').text('原绑定邮箱：' + email).siblings('input[name=email]').val(email);
                } else {
                    // window.location.href = '/mine/setting_email?op=change'
                }
            } else {
                if (Utils.UrlParams().op === 'change') {
                    // window.location.href = '/mine/setting_email'
                }
            }
        }

    }, () => {
        Global.doLogout(() => {
            window.location.href = '/user/login?from_url=' + encodeURIComponent(window.location.href);
        });
    });

    // 验证码
    $('.seccode .seccode-img').attr('src', Utils.secCodeImg());
    $('.seccode').on('click', function () {
        $(this).children('.seccode-img').attr('src', Utils.secCodeImg());
    });

    // 更换邮箱-验证邮箱
    if ('mine_setting_email' === tpl) {
        let $step1 = $('.form-section .step-imgs .step-1');
        let $step2 = $('.form-section .step-imgs .step-2');
        let capi = '',
            step = 1;
        if ($step1.hasClass('active')) {    // change
            capi = $('.form-section #input-validate-email[data-step=\'1\']').data('capi') || '';
        }

        if ($step2.hasClass('active')) {    // rechange
            capi = $('.form-section #input-validate-email[data-step=\'2\']').data('capi') || '';
            step = 2;
        }

        if (capi.length) {
            Utils.HttpRequest.get(capi, null, {crossDomain: true,}, (res) => {
                if (res.code == 1) {
                    if (step == 1) {
                        $('.form-section .step-imgs .step-2').addClass('active').siblings().removeClass('active');
                        $('.form-section #input-validate-email[data-step=\'1\']').hide();
                        $('.form-section #input-validate-email[data-step=\'2\']').show();
                        $('.form-section #to-validate-email').data('step', 2);
                    }

                    if (step == 2) {
                        $('.form-section .step-imgs .step-3').addClass('active').siblings().removeClass('active');
                        $('.form-section .bind-result').show();
                    }
                } else {
                    $('.form-section .bind-result-error').show().siblings(':not(.step-imgs)').hide();
                }
            }, () => {
                window.location.href = '/mine/setting';
            });
        }
    }
});

// 选择性别
$(".container#mine-setting #section-mine-setting #sex.setting-item .radio-item").on('click', function (e) {
    e.preventDefault();
    $(this).addClass('active').children('input[type=radio]').attr('checked',true);
    $(this).siblings('.radio-item').removeClass('active');

    let data = {
        // nickname: $(this).parents('#section-mine-setting').find('.setting-item#name .field .nickname').text(),
        sex_type: $(this).children('input[type=radio]').attr('id') === 'sex-1' ? 1 : 2,
        comment: $(this).parents('#section-mine-setting').find('.setting-item#comment .field input[name=comment]').val()
    };

    updateUserInfo(data, (res) => {}, (err) => {
        alert(err.msg);
    });
});

// 第三方账号绑定与解绑
$('.container#mine-setting #third-plt .third-plt-list').on('click', '.third-plt-item', function (e) {
    if ($(this).attr('bind') == 1) {    // 解绑
        if ($('.container#mine-setting #third-plt .third-plt-list .third-plt-item[bind=\'1\']').length <= 1) {
            return ;
        }

        let data = {
            utype: 1,   // qq
            is_sure: 1,
        };
        let typeTxt = 'QQ';

        switch ($(this).attr('id')) {
            case 'wechat':
                data.utype = 2;
                typeTxt = '微信';
                break;
            case 'qq':
                break;
            case 'weibo':
                data.utype = 3;
                typeTxt = '新浪微博';
                break;
        }

        $('.popup-modal-mask').show();
        $('.popup-modal.modal-unbind-tip').show().data('type', data.utype);
        $('.popup-modal.modal-unbind-tip').find('.content span').text(typeTxt);
    } else {    // 绑定
        console.log('bind')
    }
});

// 关闭弹窗
$('.popup-modal.modal-unbind-tip .unbind-cancel, .popup-modal.modal-del-account .btn.cancel, .popup-modal .close').on('click', function () {
    $(this).parents('.popup-modal').hide();
    $('.popup-modal-mask').hide();
});

// 确定解绑
$('.popup-modal.modal-unbind-tip .unbind').on('click', function () {
    let data = {
        utype: $(this).parents('.popup-modal').data('type'),
        is_sure: 1,
    };

    unbindSocialMediaAccount(data, () => {
        window.location.reload();
        // $(this).find('a span').removeClass('active').text('立即绑定');
    });
});

// 校验验证码，并发送验证邮件
$('.form-section#section-bind #input-validate-email .btn-login').on('click', function () {

    // 邮箱绑定与更换
    if ('mine_setting_email' === tpl) {
        let btn_type = $(this).data('type') || 'bind';

        if (btn_type === 'bind') {
            let seccode = $(this).siblings('#phone-code').find('input[name=email_code]').val().trim();
            let email = $(this).siblings('#phone').find('input[name=email]').val().trim();

            $(this).siblings('#phone').find('.tips').hide();
            if (! Utils.Validator.validateEmail(email)) {
                $(this).siblings('#phone').find('.tips').text('请输入正确的邮箱').show();
                return ;
            }

            $(this).siblings('#phone-code').find('.tips').hide();
            if (! seccode.length) {
                $(this).siblings('#phone-code').find('.tips').text('请输入正确的验证码').show();
                return ;
            }

            Utils.checkSecCode({
                op: 'seccode',
                seccode: seccode,
            }, {}, () => {  // success
                Global.checkEmail({email: email, tag: 'bind'}, (resp) => {
                    $(this).parent('#input-validate-email').hide()
                        .siblings('#to-validate-email').show().children('p:first-child').find('span').text(email);

                    if (Utils.isCommonEmail(email.split('@')[1])) {
                        $(this).parent('#input-validate-email').siblings('#to-validate-email').children('.btn-login').attr('href', 'https://mail.' + email.split('@')[1]);
                        $(this).parent('#input-validate-email').siblings('#to-validate-email').children('.uncommon-email').hide();
                    } else {
                        $(this).parent('#input-validate-email').siblings('#to-validate-email').children('.uncommon-email').show();
                        $(this).parent('#input-validate-email').siblings('#to-validate-email').children('.btn-login').hide();
                    }
                }, (e) => {
                    $(this).siblings('#phone').find('.tips').text(e.msg).show();
                })
            }, () => {  // fail
                $(this).siblings('#phone-code').find('.tips').text('请输入正确的验证码').show();
            });
        }

        if (btn_type === 'change' || btn_type === 'rechange') {
            let seccode = $(this).siblings('#phone-code').find('input[name=email_code]').val().trim();
            let email = $(this).siblings('.input-item').find('input[name=email]').val().trim();

            $(this).siblings('#phone-code').find('.tips').hide();
            if (! seccode.length) {
                $(this).siblings('#phone-code').find('.tips').text('请输入正确的验证码').show();
                return ;
            }

            Utils.checkSecCode({
                op: 'seccode',
                step: 1,
                seccode: seccode
            }, {}, () => {  // success
                Global.checkEmail({email: email, tag: btn_type}, (resp) => {
                    let $parent = $(this).parents('#input-validate-email');
                    $parent.hide();

                    $parent.siblings('#to-validate-email').data('step', btn_type === 'change' ? '1' : '2').show();
                    $parent.siblings('#to-validate-email').children('p:first-child').find('span').text(email);

                    if (Utils.isCommonEmail(email.split('@')[1])) {
                        $parent.siblings('#to-validate-email').find('.btn-login').attr('href', 'https://mail.' + email.split('@')[1]);
                        $parent.siblings('#to-validate-email').children('.uncommon-email').hide();
                    } else {
                        $parent.siblings('#to-validate-email').find('.btn-login').hide();
                        $parent.siblings('#to-validate-email').children('.uncommon-email').show();
                    }

                }, (err) => {
                    $(this).siblings('.input-item#email').find('.tips').text(err.msg).show();
                })
            }, () => {  // fail
                $(this).siblings('#phone-code').find('.tips').text('请输入正确的验证码').show();
            });
        }
    }

    // 手机号绑定与更换
    if ('mine_setting_phone' === tpl) {
        let btn_type = $(this).data('type') || 'bind';

        if (btn_type === 'bind' || btn_type === 'rechange') {
            // 手机号绑定
            let $phone = $(this).siblings('.input-item#phone').children('input[name=phone]');
            let $phoneCode = $(this).siblings('.input-item#phone-code').children('input[name=phone_code]');
            let smsCApi = $phoneCode.siblings('#sms-capi').val();

            $phone.siblings('.tips').hide();
            if (! Utils.Validator.validatePhone($phone.val().trim())) {
                $phone.siblings('.tips').text('请输入正确的手机号码').show();
                return ;
            }

            $phoneCode.siblings('.tips').hide();
            if (! $phoneCode.val().trim().length || ! smsCApi) {
                $phoneCode.siblings('.tips').show();
                return ;
            }

            let data = {
                code: $phoneCode.val().trim(),
            };

            Utils.HttpRequest.post(smsCApi, data, {crossDomain: true,}, (res) => {
                if (res.code == 1) {
                    $(this).parents('#input-validate-email').hide().siblings('.bind-result').show();

                    if (btn_type === 'bind') {
                        $(this).parents('.form-section').children('.step-imgs').find('.step.step-2').addClass('active').siblings().removeClass('active')
                    }

                    if (btn_type === 'rechange') {
                        $(this).parents('.form-section').children('.step-imgs').find('.step.step-3').addClass('active').siblings().removeClass('active')
                    }
                } else {
                    alert(res.msg);
                }
            })
        }

        // 更换手机号
        if (btn_type === 'change') {
            let $phone = $(this).siblings('.input-item#phone').children('input[name=phone]');
            let $phoneCode = $(this).siblings('.input-item#phone-code').children('input[name=phone_code]');
            let smsCApi = $phoneCode.siblings('#sms-capi').val();

            $phone.siblings('.tips').hide();
            if (! Utils.Validator.validatePhone($phone.val().trim())) {
                $phone.siblings('.tips').show();
                return ;
            }

            $phoneCode.siblings('.tips').hide();
            if (! $phoneCode.val().trim().length || ! smsCApi) {
                $phoneCode.siblings('.tips').show();
                return ;
            }

            let data = {
                code: $phoneCode.val().trim(),
            };

            Utils.HttpRequest.post(smsCApi, data, {crossDomain: true,}, (res) => {
                if (res.code == 1) {
                    $(this).parents('.form-section').children('.step-imgs').find('.step.step-2').addClass('active').siblings().removeClass('active');
                    $(this).parents('#input-validate-email').hide().siblings('#input-validate-email[data-step=2]').show();
                }
            })
        }
    }
});

// 修改密码
$('.form-section.password-setting .btn-login').on('click', function () {
    let $old_passwd = $(this).parents('.form-section').children('#password1').find('input[name=old-password]');
    let $new_passwd = $(this).parents('.form-section').children('#password2').find('input[name=new-password]');
    let $new_repasswd = $(this).parents('.form-section').children('#password3').find('input[name=confirm-password]');

    $(this).parents('.form-section').find('.tips').hide();

    if ($old_passwd.val().trim().length < 6) {
        $old_passwd.parents('.setting-item').children('.tips').show().text('密码至少6个字符');
        $old_passwd.focus();
        return ;
    }

    if ($old_passwd.val().trim().length > 14) {
        $old_passwd.parents('.setting-item').children('.tips').show().text('密码不超过14个字符');
        $old_passwd.focus();
        return ;
    }

    if ($new_passwd.val().trim().length < 6) {
        $new_passwd.parents('.setting-item').children('.tips').show().text('密码至少6个字符');
        return ;
    }

    if ($new_passwd.val().trim().length > 14) {
        $new_passwd.parents('.setting-item').children('.tips').show().text('密码不超过14个字符');
        return ;
    }

    if ($new_passwd.val().trim() != $new_repasswd.val().trim()) {
        $new_repasswd.parents('.setting-item').children('.tips').show().text('两次密码不一致');
        return ;
    }

    let resetData = {
        passwd: $old_passwd.val().trim(),
        new_passwd: $new_passwd.val().trim(),
        new_repasswd: $new_passwd.val().trim(),
    };

    Global.resetPasswd(resetData, (res) => {
        window.alert('密码修改成功，请重新登录');
        window.location.href = '/user/login?from=/mine/setting'
    }, (err) => {
        $old_passwd.parents('.setting-item').children('.tips').show().text(err.msg);
    });
});

// 修改昵称
$('.setting-item .field .change').on('click', function () {
    $(this).hide().siblings('.nickname').hide();
    $(this).siblings('input').show();
    $(this).siblings('.input-action').show();
    $(this).siblings('.tips-txt').show();
});

// 昵称修改
$('.setting-item#name .field input[name=nickname]').keyup(function () {
    let $del = $(this).siblings('.input-action.input-del');
    if ($del.length) {
        $(this).val().trim().length ? $del.show() : $del.hide();
    }
    $(this).siblings('.tips-success-icon').hide();
});

// 昵称修改
$('.setting-item#name .field input[name=nickname]').blur(function () {
    let original_nickname = $(this).siblings('.nickname').text();

    let data = {
        nickname: $(this).val().trim(),
        // sex_type: '3',
        comment: $(this).parents('#section-mine-setting').find('.setting-item#comment .field input[name=comment]').val()
    };

    if ($(this).parents('#section-mine-setting').find('.setting-item#sex .radio-item.active input[name=sex]').length) {
        data.sex_type = $(this).parents('#section-mine-setting').find('.setting-item#sex .radio-item.active input[name=sex]').attr('id') === 'sex-1' ? 1 : 2;
    }

    $(this).siblings('.tips').hide();
    $(this).siblings('.tips-success-icon').hide();
    if (data.nickname.length < 2) {
        $(this).siblings('.tips-txt').hide();
        $(this).siblings('.tips').show().text('昵称不少于2字符');

        return ;
    }
    if (data.nickname.length > 20) {
        $(this).siblings('.tips-txt').hide();
        $(this).siblings('.tips').show().text('昵称不超过20字符');

        return ;
    }

    updateUserInfo(data, (res) => {
        $(this).siblings('.tips-txt').hide();
        $(this).siblings('.input-action').hide();
        $(this).siblings('.tips-success-icon').show();
    }, (err) => {
        console.log(err);
    });
});

// 注销账号-打开弹窗
$('.setting-item#del-account .field .del').on('click', function () {
    $('.popup-modal.modal-del-account').show();
    $('.popup-modal-mask').show();
});

// 弹窗-确定
$('.popup-modal .actions .confirm').on('click', function () {
    // 确定注销账户
    if ($(this).parents('.popup-modal').hasClass('modal-del-account')) {
        delAccount(() => {
            $('.popup-modal-mask').hide();
            $(this).parents('.popup-modal').hide();
            $('.popup-modal.modal-del-account-success').show();
            Global.doLogout(() => {
                setTimeout(() => {
                    window.location.href = '/user/login?_delAccount=1';
                }, 2000);
            });
        }, (error) => {
            console.log(error);
        });
    }
});

/**
 * 解绑相关账号
 * @param data
 * @param callback
 */
let unbindSocialMediaAccount = (data, callback) => {
    let options = {
        isSign: true,
        ac: 'UserUnion.Unbind',
        crossDomain: true,
    };

    Utils.HttpRequest.post('https://i.gwdang.com/UserUnion/Unbind', data, options, (response) => {
        if (response.code == 1) {
            callback && 'function' === typeof callback && callback();
        } else {
            console.log(response)
        }
    })
};

/**
 * 生成第三方账号绑定的地址
 * @param $dom
 * @param sign 手动传入参数
 * @param success 成功回调
 */
let generateSocialMediaBindUrl = function ($dom, sign, success) {
    if (! sign || ! Object.keys(sign).length) {
        sign = {
            ac: 'UserUnion.Authorize'.toLowerCase(),
            utype: $dom.data('oauth-type'),
            isBind: 1,
            platform: 'pc',
            t: (new Date().getTime() / 1e3).toFixed(0),
        }
    }

    let sign_str = Utils.DataSign(sign);
    delete sign['ac'];
    let data_arr = [];
    Object.keys(sign).forEach((k) => {
        data_arr.push(k + '=' + sign[k])
    });
    data_arr.push('sign=' + sign_str);
    $dom.attr('href', 'https://i.gwdang.com/UserUnion/Authorize?' + data_arr.join('&'));

    success && 'function' === typeof success && success();
};

/**
 * 删除购物党账号
 * @param success
 * @param error
 */
let delAccount = function (success, error) {
    let options = {
        isSign: true,
        ac: 'User.Dispose',
        crossDomain: true,
    };

    let data = {
        ensure: 1
    };

    // success && 'function' === typeof success && success();
    // return;
    Utils.HttpRequest.post('https://i.gwdang.com/User/Dispose', data, options, (response) => {
        console.log(response);
        if (response.code == 1) {
            success && 'function' === typeof success && success();
        } else {
            error && 'function' === typeof error && error(response);
        }
    });
};

/**
 * 更新用户信息
 * @param data
 * @param success
 * @param error
 */
let updateUserInfo = (data, success, error) => {
    let options = {
        isSign: true,
        ac:'User.Modify',
        crossDomain: true,
    };

    Utils.HttpRequest.post('https://i.gwdang.com/User/Modify', data, options, (resp) => {
        if (resp.code == 1) {
            success && 'function' === typeof success && success(resp);
        } else {
            error && 'function' === typeof error && error(resp);
        }
    }, (err) => {});
};
